<template lang="pug">
  TabWrapper.elevation-2(type="profile")
    FormWrapper(type="password")
      template(v-slot:default="props")
        PasswordForm(
          :model="props.model",
          :redirect-route="{ name: 'editProfile' }",
          :submit-fn="submitFn",
          :validate="props.validate",
          :valid="props.valid",
        )
</template>

<script>
import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import PasswordForm from '@/components/forms/Password.vue';
import ProfileForm from '@/components/forms/Profile.vue';
import TabWrapper from '@/components/wrapper/TabWrapper.vue';

export default {
  components: {
    FormWrapper,
    PasswordForm,
    ProfileForm,
    TabWrapper,
  },

  methods: {
    submitFn(payload) {
      return this.$store.dispatch('auth/updatePassword', payload, {
        root: true,
      });
    },
  },
};
</script>
